export default __webpack_public_path__ + "static/funnel-experiment-calculation-dark-505a6f1ec1878c7e400ec2fe1fa5ce9a.png";